import React, { useState } from "react";
import { API_BASE_URL } from "../../../../api/api";
import { Link } from "react-router-dom";
import { StarRating } from "../../../common/StarRating";
import { toast } from "react-toastify";
import { getInitials, getPracticeMapUrl } from "../../../../utils/helper";
import { PhotoProvider, PhotoView } from "react-photo-view";

const PracticeCardMap = ({ item,
    setSelectedPractice,
    selectedPractice
}) => {

    const handleClickItem = (e) => {

        if(selectedPractice?.practices_id === item?.practices_id)
        {
            setSelectedPractice(null)
            return;
        }

        if (setSelectedPractice) {
            if(item?.latitude && item?.longitude)
            {
                setSelectedPractice(item)
            }
            else 
            {
                toast.error("Not available in the map.")
                setSelectedPractice(null)

            }
        }
        else {
            toast.error("Not available in the map.")
        }
    }

    return (
        <>
            <div className="card-practitioners sm:px-10 px-4 py-6">
                <div className="w-full flex flex-wrap gap-y-3 listcardwrapper">
                    <div className="w-[100px] sm:w-[140px] imgcard">
                        <div onClick={handleClickItem}
                            className="cursor-pointer">
                            {item?.image ? (                                
                                <img src={item.image ? API_BASE_URL + item.image : null} alt="" className="w-full rounded-lg aspect-square object-cover mb-1.5" />
                            ) : (
                                <div className="w-full rounded-lg aspect-square object-cover mb-1.5 bg-gray-200 flex items-center justify-center text-5xl overflow-hidden font-semibold text-gray-700">
                                    {item?.practice_name && getInitials(item?.practice_name)}
                                </div>
                            )}
                        </div>
                        {/* <button className=" py-2 bg-transparent text-dark border border-dark text-xs sm:text-base w-full flex items-center justify-center font-semibold rounded border-solid max-w-[130px] mx-auto">Add Logo</button> */}
                    </div>
                    <div className="w-[calc(100%-100px)] sm:w-[calc(100%-140px)] pl-3 sm:pl-6 contentcard">
                        <div className="">
                            {/* <Link to={item.is_practitioner === 0 ? `/${postcode}/${slug}/${item?.slug}` : `/${postcode}/${slug}/${item?.practice?.slug}/${item?.slug}`} className="text-base sm:text-lg block w-fit font-semibold text-gray-800 mb-1 sm:mb-2 ">
                                <span>{item?.practice_name}</span>
                                {item?.is_verified == 1
                                    &&
                                    <span className="float-right mt-1 pl-2">
                                        <img src="/assets/image/verifiedicon.svg" alt="" srcSet="" />
                                    </span>
                                }
                            </Link> */}

                            <div
                                // onClick={() => setSelectedPractice ? setSelectedPractice(item) : toast.error("Not available in map")}
                                onClick={handleClickItem}
                                className="text-base sm:text-lg block w-fit font-semibold text-gray-800 mb-1 sm:mb-2 cursor-pointer">
                                <span>{item?.practice_name}</span>
                                {item?.is_verified == 1
                                    &&
                                    <span className="float-right mt-1 pl-2">
                                        <img src="/assets/image/verifiedicon.svg" alt="" srcSet="" />
                                    </span>
                                }
                            </div>

                            {item?.is_practitioner == 1 &&
                                <div className="flex items-center flex-wrap gap-x-3 gap-y-1 mb-2 sm:mb-3">
                                    <span className="text-green font-medium text-xs">{item?.services?.map(service => service.name).join(", ")}</span>
                                </div>
                            }

                            <div className="mb-2 sm:mb-3">
                                <StarRating rating={Number(item?.reviews?.reviews_avg) || 0} reviews_count={item?.reviews?.reviews_count} />
                            </div>
                            {item?.address &&
                                <Link
                                    to={getPracticeMapUrl(item)}
                                    target="_blank" rel="noopener noreferrer"
                                    className="flex gap-x-2  gap-y-1 sm:items-center mb-2 sm:mb-3">
                                    <svg width="24" className="w-5 h-5 mt-1 sm:mt-0" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z" fill="#0052CC" />
                                    </svg>
                                    <span className="text-dark text-xs font-medium underline underline-offset-[2px] w-[calc(100%-24px)] sm:w-[calc(100%-36px)]">{item?.address}, {item?.suburb?.name} {item?.state?.name} {item?.postcode?.postcode}</span>
                                </Link>
                            }
                            <p className="text-xs text-dark font-medium mb-2">
                                {item?.short_description?.length > 100
                                    ? `${item.short_description.slice(0, 100)}...`
                                    : item.short_description}
                            </p>
                            <PhotoProvider>
                                <div className="flex flex-wrap gap-3">
                                    {item?.practices_images?.length > 0 && item?.practices_images.slice(0,5).map((image_item, index) => (
                                        <PhotoView key={index} src={image_item?.image_url ? API_BASE_URL + image_item?.image_url : null}>
                                            <img src={image_item?.image_url ? API_BASE_URL + image_item?.image_url : null} className="h-12 w-12 object-cover object-center rounded-lg cursor-pointer" alt="" />
                                        </PhotoView>
                                    ))}
                                </div>
                            </PhotoProvider>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
        </>
    )
};

export default PracticeCardMap;
